import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { SubmitDocumentsEsignature } from '../../Models/Domains/Documents/SubmitDocumentsEsignature';

declare var IS_RUNNING_IN_APP_POOL;

export class ESignatureDocumentTaskRequestSubmitClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(submitDocumentsEsignatureCommand: SubmitDocumentsEsignature): Promise<string, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Documents/ESignatureDocumentTaskRequestSubmit/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { submitDocumentsEsignatureCommand: submitDocumentsEsignatureCommand }

    return AjaxWrapper.post<string, any>(url, data);
  }
}

